module.exports = __webpack_public_path__ + "img/Empty.6c551c31.svg";